
import React from 'react';

import NonFSIndex from "@dndComponents/NonFSIndex";

export default function SpellListIndex() {
  return (
    <NonFSIndex
      data_type="spell_list"
    />
  );
}
